import React from 'react';
import Relay, { graphql } from 'react-relay';
import FieldLoader, { AutoCompleteHandler } from '../FieldLoader';

const loaderQuery = graphql`
  query UserRoleLoaderQuery (
    $first: Int,
    $offset: Int
  ) {
    viewer {
      ...UserRoleLoaderFragment_viewer
      @arguments(
        first: $first,
        offset: $offset,
      )
    }
  }
`;

const refetchContainer = Relay.createRefetchContainer(
  AutoCompleteHandler,
  {
    viewer: graphql`
      fragment UserRoleLoaderFragment_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10 }
        offset: {type: Int, defaultValue: 0 }
        search: {type: String, defaultValue: null}
      ) {
        userRoles (
          first: $first
          offset: $offset
          search: $search
        ) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  },
  graphql`
    query UserRoleLoaderRefetchQuery(
      $first: Int!
      $offset: Int!
      $search: String!
    ) {
      viewer {
        ...UserRoleLoaderFragment_viewer
        @arguments(
          first: $first,
          offset: $offset,
          search: $search,
        )
      }
    }
  `,
);

const getOptionLabel = option => option.name;
const getOptionSelected = (option, value) => option.id === value.id && option.name === value.name;
const nodeCollector = viewer => viewer.userRoles.edges.map(edge => edge.node);

export default function UserRoleLoader(props) {
  return (
    <FieldLoader
      loaderQuery={loaderQuery}
      refetchContainer={refetchContainer}
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      nodeCollector={nodeCollector}
      {...props}
    />
  );
}
